const DEFAULT_POST_LOGIN_PATH = '/home';
const BLOCKED_PREFIXES = ['/login', '/logout', '/forbidden', '/api/'];

interface RedirectFrom {
    pathname?: unknown;
    search?: unknown;
    hash?: unknown;
}

const safeRedirectPath = (candidate: unknown): string => {
    if (typeof candidate !== 'string') return DEFAULT_POST_LOGIN_PATH;
    if (!candidate.startsWith('/')) return DEFAULT_POST_LOGIN_PATH;
    if (candidate.startsWith('//') || candidate.startsWith('/\\')) return DEFAULT_POST_LOGIN_PATH;
    if (
        BLOCKED_PREFIXES.some(
            (p) => candidate === p || candidate.startsWith(`${p}?`) || candidate.startsWith(`${p}/`)
        )
    ) {
        return DEFAULT_POST_LOGIN_PATH;
    }
    return candidate;
};

export function postLoginRedirect(locationState: unknown, locationSearch: string): string {
    const stateFrom = (locationState as { from?: unknown } | null)?.from as
        RedirectFrom | undefined;
    if (stateFrom && typeof stateFrom.pathname === 'string') {
        const search = typeof stateFrom.search === 'string' ? stateFrom.search : '';
        const hash = typeof stateFrom.hash === 'string' ? stateFrom.hash : '';
        return safeRedirectPath(`${stateFrom.pathname}${search}${hash}`);
    }
    const queryFrom = new URLSearchParams(locationSearch).get('from');
    return safeRedirectPath(queryFrom);
}
